import React, { useState, useEffect, useRef } from "react";
import { ResizableBox } from "react-resizable";
import * as Icon from "react-feather";
import {
  Form,
  Accordion,
} from "react-bootstrap";
import { toast } from "react-toastify";
import DatajoltSpinner from "../global/DatajoltSpinner";
import "./SidebarModal.css";
import { Trash2 } from 'react-feather';
import { fetchAvaialbleTestsService, fetchColumnsFromEditorService, fetchTestsService, handleSaveTestsService } from "../../services/editor";
import { Button, CircularProgress, menuClasses } from "@mui/material";
import Row from "../global/Layout/Row"
import Col from "../global/Layout/Col"
import Dropdown from "../global/Dropdown";

export default function DataQualityTestsCRUD({ onClose, currentModelName, dbt_url, branch, editorContent,updateFiles,files,updateFileContentWithoutUnsaved,triggerReload }) {
  const [isLoading, setIsLoading] = useState(true);  // Start with loading state true
  const [isSaving, setIsSaving] = useState(false);
  const [columnTests, setColumnTests] = useState({});
  const [tableTests, setTableTests] = useState({});
  const [showColumnDropdowns, setShowColumnDropdowns] = useState(false);
  const [showTableDropdowns, setShowTableDropdowns] = useState(false);
  const [selectedColumn, setSelectedColumn] = useState('');
  const [selectedColumnTest, setSelectedColumnTest] = useState('');
  const [selectedTableTest, setSelectedTableTest] = useState('');
  const [availableTests, setAvailableTests] = useState({ column: [], table: [] });
  const [selectedColumnTestConfig, setSelectedColumnTestConfig] = useState({});
  const [selectedTableTestConfig, setSelectedTableTestConfig] = useState({});
  const [columnTestInputValues, setColumnTestInputValues] = useState({});
  const [tableTestInputValues, setTableTestInputValues] = useState({});
  const [loadingCols, setLoadingCols] = useState(true);
  const dropdonwContainerRef = useRef(null);
  const [dropdownWidth, setDropdownWidth] = useState(0);


  useEffect(() => {
    fetchData();
  }, [currentModelName, dbt_url, branch, triggerReload]);

  const [columns, setColumns] = useState([]);

  const fetchData = async () => {
    setIsLoading(true);
    fetchColumnsFromEditor(); // This is now called without awaiting
    try {
      await Promise.all([
        fetchTests(),
        fetchAvailableTests()
      ]);
    } catch (error) {
      console.error("Error fetching data:", error);
      toast.error("An error occurred while fetching data.");
    } finally {
      setIsLoading(false);
    }
  };

  const fetchTests = async () => {
    const response = await fetchTestsService(dbt_url, currentModelName, branch);

    if(response) {
      setColumnTests(response.columnTests);
      setTableTests(response.tableTests);
    }
  };

  const fetchAvailableTests = async () => {
    try {
      const response = await fetchAvaialbleTestsService(dbt_url);
      setAvailableTests(response.data);
    } catch (error) {
      throw error;  // Propagate the error
    }
  };

  const fetchColumnsFromEditor = async () => {
    setLoadingCols(true);

    const response = await fetchColumnsFromEditorService(dbt_url, {
      sql: editorContent,
      tabname: getFileName(currentModelName),
      dbt_branch: branch,
      rows:1,
    })

    if(response) {
      setColumns(
        response.data.columns
          .filter((column) => !column.startsWith("_airbyte"))
          .sort((a, b) => a.localeCompare(b))
      );
    }

    setLoadingCols(false);
  };

  
  const handleColumnParamChange = (columnName, testName, paramName, value) => {
    setColumnTests(prevTests => ({
      ...prevTests,
      [columnName]: prevTests[columnName].map(test =>
        test.name === testName ? { ...test, params: { ...test.params, [paramName]: value } } : test
      )
    }));
  };

  const handleTableParamChange = (testName, paramName, value) => {
    setTableTests(prevTests => ({
      ...prevTests,
      [testName]: {
        ...prevTests[testName],
        params: {
          ...prevTests[testName].params,
          [paramName]: value
        }
      }
    }));
  };

  const handleDeleteTest = (testType, columnName, testName) => {
    if (testType === 'column') {
      setColumnTests(prevTests => {
        const updatedTests = { ...prevTests };
        if (updatedTests[columnName]) {
          updatedTests[columnName] = updatedTests[columnName].filter(test => test.name !== testName);
          if (updatedTests[columnName].length === 0) {
            delete updatedTests[columnName];
          }
        }
        return updatedTests;
      });
    } else if (testType === 'table') {
      setTableTests(prevTests => {
        const updatedTests = { ...prevTests };
        delete updatedTests[testName];
        return updatedTests;
      });
    }
  };

  const sortParams = (params) => {
    const sortedParams = {};
    const keys = Object.keys(params).sort((a, b) => {
      if (a.includes('.') && !b.includes('.')) return 1;
      if (!a.includes('.') && b.includes('.')) return -1;
      return 0;
    });
    keys.forEach(key => {
      sortedParams[key] = params[key];
    });
    return sortedParams;
  };

  const renderColumnTests = () => {
    return Object.entries(columnTests).map(([columnName, tests], index, array) => (
      <div key={columnName} className="custom-accordion-item">
        <Accordion className="custom-accordion">
          <Accordion.Item eventKey={columnName}>
            <Accordion.Header className="d-flex align-items-center justify-content-between w-100">
              <div>
              <span className="me-2" style={{ wordBreak: "break-word", overflowWrap: "break-word" }}>{columnName}</span>
                <span className="text-muted small" style={{ wordBreak: "break-word", overflowWrap: "break-word" }}>
                  ({tests.map(test => test.name).join(', ')})
              </span>
              </div>
            </Accordion.Header>
            <Accordion.Body>
              {tests.map((test, testIndex) => (
                <div key={testIndex} className="mb-3 d-flex align-items-center">
                  <Button
                    variant="text"
                    onClick={() => handleDeleteTest('column', columnName, test.name)}
                    sx={{
                      padding: 0,
                      marginRight: "0.5rem",
                      minWidth: 0,
                      width: "max-content",
                      display: "inline-block",
                      alignSelf: "center"
                    }}
                  >
                    <Trash2 size={16} className="text-danger" />
                  </Button>
                  <div className="flex-grow-1">
                  <h6 className="mb-0" style={{fontSize: '0.875rem', wordBreak: "break-word", overflowWrap: "break-word"}}>{test.name}</h6>
                  {Object.entries(sortParams(test.params)).length > 0 ? (
                      Object.entries(sortParams(test.params)).map(([paramName, paramValue]) => (
                        <Form.Group key={paramName} className="mb-2 d-flex align-items-center">
                          <Form.Label className="mb-0 me-2 common-label" style={{minWidth: '100px', fontSize: '0.75rem'}}>
                            {paramName}:
                          </Form.Label>
                          <Form.Control
                            type="text"
                            size="sm"
                            value={paramValue}
                            onChange={(e) => handleColumnParamChange(columnName, test.name, paramName, e.target.value)}
                            className="fixed-width-input"
                            style={{fontSize: "11px"}}
                          />
                        </Form.Group>
                      ))
                    ) : (
                      <div className="text-muted" style={{fontSize: '0.75rem'}}>No parameters</div>
                    )}
                  </div>
                </div>
              ))}
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
        {index < array.length - 1 && <hr className="my-2" />}
      </div>
    ));
  };

  const renderTableTests = () => {
    return Object.entries(tableTests).map(([testName, test], index, array) => (
      <div key={testName} className="custom-accordion-item">
        <Accordion className="custom-accordion">
          <Accordion.Item eventKey={testName}>
            <Accordion.Header>
              <div className="d-flex justify-content-between align-items-center w-100">
                <div className="d-flex align-items-center">
                  <Button
                    variant="text"
                    onClick={(e) => {
                      e.stopPropagation();
                      handleDeleteTest('table', null, testName);
                    }}
                    sx={{
                      padding: 0,
                      marginRight: "0.5rem",
                      minWidth: 0,
                      width: "max-content",
                      display: "inline-block",
                      alignSelf: "center"
                    }}
                  >
                    <Trash2 size={16} className="text-danger" />
                  </Button>
                  <span style={{ wordBreak: "break-word", overflowWrap: "break-word" }}>{testName}</span>
                </div>
              </div>
            </Accordion.Header>
            <Accordion.Body>
              {Object.entries(sortParams(test.params)).length > 0 ? (
                Object.entries(sortParams(test.params)).map(([paramName, paramValue]) => (
                  <Form.Group key={paramName} className="mb-2" style={{ display: "flex", flexDirection: "column" }}>
                    <Form.Label className="mb-1 common-label" style={{ wordBreak: "break-word", overflowWrap: "break-word" }}>
                      {paramName}:
                    </Form.Label>
                    <Form.Control
                      type="text"
                      size="sm"
                      value={paramValue}
                      onChange={(e) => handleTableParamChange(testName, paramName, e.target.value)}
                      className="fixed-width-input w-100"
                      style={{ wordBreak: "break-word", overflowWrap: "break-word", fontSize: "11px" }}
                    />
                  </Form.Group>
                ))
              ) : (
                <div className="text-muted" style={{fontSize: '0.75rem'}}>No parameters</div>
              )}
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
        {index < array.length - 1 && <hr className="my-2" />}
      </div>
    ));
  };

  const handleAddColumnTest = () => {
    setShowColumnDropdowns(!showColumnDropdowns);
    setShowTableDropdowns(false);
  };

  const handleAddTableTest = () => {
    setShowTableDropdowns(!showTableDropdowns);
    setShowColumnDropdowns(false);
  };

  const handleSaveTests = async () => {
    setIsSaving(true);
    
    const response = await handleSaveTestsService(dbt_url, { columnTests, tableTests, currentModelName, branch })

    if(response) {
      // Check if schema.yml is in open files and update if present
      const schemaYmlPath = `${response.data.path}/schema.yml`;

      if (Object.keys(files).includes(schemaYmlPath)) {
          updateFileContentWithoutUnsaved(schemaYmlPath, response.data.schema_yml);
      }
      onClose();
    }
    setIsSaving(false);
  };

  // Function to extract filename from path
  const getFileName = (path) => {
    if (!path) return '';
    const parts = path.split('/');
    const fileNameWithExtension = parts[parts.length - 1];
    return fileNameWithExtension.replace('.sql', '');
  };

  const handleSelectColumnTest = (test) => {
    setSelectedColumnTest(test.name);
    setSelectedColumnTestConfig(test.inputs || {});
    setColumnTestInputValues({}); // Reset input values
  };

  const handleSelectTableTest = (test) => {
    setSelectedTableTest(test.name);
    setSelectedTableTestConfig(test.inputs || {});
    setTableTestInputValues({}); // Reset input values
  };

  const renderInputFields = (config, prefix = '') => {
    const sortedConfig = sortParams(config);
    return Object.entries(sortedConfig).map(([key, value]) => {
      const fullKey = prefix ? `${prefix}.${key}` : key;
      if (Array.isArray(value)) {
        return (
          <div key={fullKey} className="mb-2">
            {value.map((item, index) => (
              <Form.Group key={`${fullKey}.${index}`} className="mb-2 d-flex align-items-center justify-content-between">
                <Form.Label className="mb-0 me-2 common-label">
                  {`${key} (${index + 1}):`}
                </Form.Label>
                <Form.Control
                  type="text"
                  size="sm"
                  placeholder={item}
                  onChange={(e) => handleInputChange(`${fullKey}.${index}`, e.target.value)}
                  className="fixed-width-input"
                  style={{fontSize: "11px"}}
                />
              </Form.Group>
            ))}
          </div>
        );
      } else if (typeof value === 'object' && value !== null) {
        return (
          <div key={fullKey} className="nested-accordion-item">
            <Accordion className="nested-accordion">
              <Accordion.Item eventKey={fullKey}>
                <Accordion.Header>{key}</Accordion.Header>
                <Accordion.Body>
                  {renderInputFields(value, fullKey)}
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>
          </div>
        );
      } else {
        return (
          <Form.Group key={fullKey} className="mb-2 d-flex align-items-center justify-content-between">
            <Form.Label className="mb-0 me-2 common-label">
              {key}:
            </Form.Label>
            <Form.Control
              type="text"
              size="sm"
              placeholder={value}
              onChange={(e) => handleInputChange(fullKey, e.target.value)}
              className="fixed-width-input"
              style={{fontSize: "11px"}}
            />
          </Form.Group>
        );
      }
    });
  };

  const handleInputChange = (key, value) => {
    if (showColumnDropdowns) {
      setColumnTestInputValues(prev => ({...prev, [key]: value}));
    } else if (showTableDropdowns) {
      setTableTestInputValues(prev => ({...prev, [key]: value}));
    }
  };

  // Calculate the count of column tests
  const columnTestCount = Object.values(columnTests).reduce((count, tests) => count + tests.length, 0);

  // Calculate the count of table tests
  const tableTestCount = Object.keys(tableTests).length;

  const handleSaveNewTest = () => {
    if (showColumnDropdowns && selectedColumn && selectedColumnTest) {
      // Check if the column test already exists
      const existingColumnTest = columnTests[selectedColumn]?.find(test => test.name === selectedColumnTest);
      if (existingColumnTest) {
        toast.info('This column test already exists.');
        return;
      }

      const allRequiredInputsFilled = Object.entries(selectedColumnTestConfig).every(([key, value]) => {
        return columnTestInputValues[key] !== undefined && columnTestInputValues[key] !== '' || 
               (typeof value === 'string' && value.toLowerCase().includes('optional') || key === 'config.error_if' || key === 'config.severity' || key === 'config.warn_if');
      });
      if (allRequiredInputsFilled) {
        const filteredInputs = Object.fromEntries(
          Object.entries(columnTestInputValues).filter(([key, value]) => value !== '')
        );
        setColumnTests(prevTests => ({
          ...prevTests,
          [selectedColumn]: [
            ...(prevTests[selectedColumn] || []),
            { name: selectedColumnTest, params: sortParams(filteredInputs) }
          ]
        }));
        setSelectedColumn('');
        setSelectedColumnTest('');
        setColumnTestInputValues({});
        setShowColumnDropdowns(false);
      } else {
        toast.info('Please fill in all required inputs for the column test.');
      }
    } else if (showTableDropdowns && selectedTableTest) {
      // Check if the table test already exists
      if (tableTests[selectedTableTest]) {
        toast.info('This table test already exists.');
        return;
      }

      const allRequiredInputsFilled = Object.entries(selectedTableTestConfig).every(([key, value]) => {
        return tableTestInputValues[key] !== undefined && tableTestInputValues[key] !== '' || 
               (typeof value === 'string' && value.toLowerCase().includes('optional'));
      });
      if (allRequiredInputsFilled) {
        const filteredInputs = Object.fromEntries(
          Object.entries(tableTestInputValues).filter(([key, value]) => value !== '')
        );
        setTableTests(prevTests => ({
          ...prevTests,
          [selectedTableTest]: {
            name: selectedTableTest,
            params: sortParams(filteredInputs)
          }
        }));
        setSelectedTableTest('');
        setTableTestInputValues({});
        setShowTableDropdowns(false);
      } else {
        toast.info('Please fill in all required inputs for the table test.');
      }
    } else {
      toast.error('Please provide all required fields before saving the test.');
    }
  };

  // Function to render the test name with badge
  const renderTestWithBadge = (testName) => {
    if (testName.includes('.')) {
      const [packageName, ...rest] = testName.split('.');
      const testNameWithoutPackage = rest.join('.');
      return (
        <div className="d-flex align-items-center flex-wrap">
          <span className="badge bg-primary me-1 mb-1" style={{ fontSize: '0.65rem' }}>{packageName}</span>&nbsp;
          <span className="text-wrap">{testNameWithoutPackage}</span>
        </div>
      );
    } else {
      return (
        <div className="d-flex align-items-center flex-wrap">
          <span className="badge bg-secondary me-1 mb-1" style={{ fontSize: '0.65rem' }}>generic</span>&nbsp;
          <span className="text-wrap">{testName}</span>
        </div>
      );
    }
  };

  return (
    <ResizableBox
      className={`dragged-box react-resizable sidebar-modal-wrapper`}
      height={window.innerHeight - 50}
      width={window.innerWidth / 3}
      maxConstraints={[window.innerWidth - 65, window.innerHeight - 50]}
      minConstraints={[400, 400]}
      resizeHandles={["w"]}
      id="data-quality-tests-crud-modal"
      style={{
        zIndex: 10000, // Higher z-index to ensure it appears above Robin ChatSidebar
        position: 'relative',
        boxShadow: '0 0 10px rgba(0, 0, 0, 0.2)'
      }}
    >
      <style>
        {`
          #data-quality-tests-crud-modal .dropdown-menu {
            left: 0 !important;
            right: auto !important;
            transform: none !important;
            bottom: 100% !important; /* Changed from top: 100% to bottom: 100% */
            top: auto !important;    /* Added to override any top value */  
            width: 100% !important;
            position: absolute !important;
            max-height: 200px !important;
            overflow-y: auto !important;
          }
          
          /* Enhanced fix for ChatSidebar border showing through */
          #data-quality-tests-crud-modal {
            isolation: isolate;
            background: white;
            border-left: 5px solid white !important;
          }
          
          /* Ensure the content section has proper background */
          .schedule-sidebar-content {
            background: white;
            position: relative;
            z-index: 1;
          }
        `}
      </style>
      <section className="schedule-sidebar-content">
        <h2 style={{ marginBottom: '12px', position: 'relative' }}>
          <span
            style={{
              display: 'flex',
              alignItems: 'center',
              padding: '10px',
              borderRadius: '10px',
              background: 'rgba(85, 110, 230, 0.08)',
              color: '#556ee6',
              fontWeight: '600',
              fontSize: '13px',
              letterSpacing: '0.2px',
              boxShadow: '0 2px 6px rgba(85, 110, 230, 0.1)',
              border: '2px solid rgba(19, 25, 59, 0.15)',
              position: 'relative',
              paddingRight: '45px',
              width: '100%'
            }}
          >
            <Icon.ChevronsRight
              color="#556ee6"
              onClick={onClose}
              role="button"
              style={{ cursor: 'pointer', marginRight: '8px' }}
              size={16}
            />
            <span style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
              Data Quality Tests: {getFileName(currentModelName)}
            </span>
            <svg 
              xmlns="http://www.w3.org/2000/svg" 
              fill="none" 
              viewBox="0 0 24 24" 
              height="18" 
              width="18"
              style={{
                position: 'absolute',
                right: '15px',
                top: '50%',
                transform: 'translateY(-50%)'
              }}
            >
              <path
                fill={"#ff694a"}
                d="M22.75135 1.2273975C23.303775 1.75859 23.665 2.459765 23.75 3.224675c0 0.318725 -0.085 0.5312 -0.276225 0.934925 -0.191225 0.4037 -2.549725 4.483275 -3.2509 5.6094 -0.4037 0.658675 -0.616175 1.44485 -0.616175 2.20975 0 0.786175 0.212475 1.5511 0.616175 2.209775 0.701175 1.126125 3.059675 5.226925 3.2509 5.63065C23.665 20.222875 23.75 20.4141 23.75 20.7328c-0.085 0.764925 -0.42495 1.466125 -0.9774 1.976075 -0.5312 0.552425 -1.23235 0.91365 -1.976025 0.977375 -0.318725 0 -0.5312 -0.084975 -0.91365 -0.276225 -0.382475 -0.191225 -4.547025 -2.485975 -5.673175 -3.18715 -0.084975 -0.0425 -0.169975 -0.106225 -0.2762 -0.14875L8.36665 16.780725c0.127475 1.0624 0.594925 2.0823 1.359825 2.825975 0.14875 0.148725 0.2975 0.276225 0.467475 0.4037 -0.1275 0.063725 -0.276225 0.1275 -0.4037 0.212475 -1.12615 0.701175 -5.22695 3.059675 -5.63065 3.2509C3.755875 23.665 3.56465 23.75 3.224675 23.75c-0.76491 -0.085 -1.466085 -0.42495 -1.9760325 -0.9774C0.6962025 22.2414 0.33499 21.54025 0.25 20.775325c0.0212475 -0.318725 0.10624 -0.637425 0.2762225 -0.91365 0.19123 -0.403725 2.5497275 -4.50455 3.2509025 -5.630675 0.403725 -0.658675 0.616175 -1.4236 0.616175 -2.20975 0 -0.786175 -0.21245 -1.5511 -0.616175 -2.209775 -0.701175 -1.1686 -3.0809225 -5.269425 -3.2509025 -5.67315C0.35624 3.8621 0.2712475 3.5434 0.25 3.224675c0.08499 -0.76491 0.424955 -1.466085 0.9773975 -1.9972775C1.75859 0.674955 2.459765 0.33499 3.224675 0.25c0.318725 0.0212475 0.637425 0.10624 0.934925 0.2762225 0.33995 0.1487325 3.335875 1.8910475 4.92945 2.8259525l0.361225 0.212475c0.127475 0.085 0.233725 0.148725 0.318725 0.191225l0.169975 0.106225 5.673125 3.357175c-0.127475 -1.274875 -0.78615 -2.443525 -1.80605 -3.229675 0.1275 -0.063725 0.276225 -0.1275 0.4037 -0.212475 1.12615 -0.701175 5.22695 -3.0809225 5.63065 -3.2509025 0.27625 -0.1699825 0.59495 -0.254975 0.934925 -0.2762225 0.743675 0.08499 1.44485 0.424955 1.976025 0.9773975ZM12.29745 13.5086l1.21115 -1.21115c0.169975 -0.169975 0.169975 -0.424925 0 -0.5949l-1.21115 -1.21115c-0.169975 -0.169975 -0.424925 -0.169975 -0.5949 0l-1.21115 1.21115c-0.169975 0.169975 -0.169975 0.424925 0 0.5949l1.21115 1.21115c0.148725 0.148725 0.424925 0.148725 0.5949 0Z"
                strokeWidth="0.25"
              />
            </svg>
          </span>
        </h2>

        {isLoading ? (
          <div className="d-flex justify-content-center align-items-center" style={{ height: '100%' }}>
            <DatajoltSpinner />
          </div>
        ) : (
          <>
            <Accordion defaultActiveKey="0" className="pl-0 mb-3">
              <Accordion.Item 
                eventKey="0"
                style={{
                  borderRadius: '18px',
                  background: 'linear-gradient(to bottom, #fff, #f9fbfe)',
                  boxShadow: '0 8px 20px rgba(85, 110, 230, 0.1), 0 2px 8px rgba(0, 0, 0, 0.05)',
                  overflow: 'hidden',
                  border: 'none',
                  transition: 'all 0.05s ease-in-out'
                }}
              >
                <Accordion.Header
                  style={{
                    background: 'transparent',
                    border: 'none',
                    width: '100%',
                    borderRadius: '18px 18px 0 0',
                    transition: 'all 0.3s ease'
                  }}
                >
                  <div
                    className="d-flex align-items-center w-100" 
                    style={{ 
                      fontWeight: '600', 
                      fontSize: '12px', 
                      color: '#556ee6',
                      letterSpacing: '0.2px'
                    }}
                  >
                    <div
                      style={{
                        backgroundColor: 'rgba(85, 110, 230, 0.1)',
                        borderRadius: '50%',
                        width: '32px',
                        height: '32px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        marginRight: '12px',
                        transition: 'all 0.2s ease',
                        boxShadow: '0 2px 5px rgba(46, 202, 106, 0.2)'
                      }}
                    >
                      <Icon.Columns size={16} />
                    </div>
                    Column Tests ({columnTestCount})
                  </div>
                </Accordion.Header>
                <Accordion.Body
                  style={{ 
                    padding: '18px 25px 22px',
                    backgroundColor: 'rgba(85, 110, 230, 0.03)',
                    borderTop: '1px solid rgba(85, 110, 230, 0.05)',
                    borderRadius: '0 0 18px 18px',
                    transition: 'all 0.3s ease-in-out'
                  }}
                >
                  {renderColumnTests()}
                  
                  {showColumnDropdowns && (
                    <div 
                      className="create-test-box mt-3 mb-2"
                      style={{
                        background: "white",
                        borderRadius: "12px",
                        padding: "20px",
                        boxShadow: "0 4px 20px rgba(0, 0, 0, 0.05)",
                        border: "1px solid rgba(230, 235, 245, 0.8)"
                      }}
                    >
                      <h6 
                        className="create-test-title"
                        style={{
                          fontSize: "12px",
                          fontWeight: "600",
                          marginBottom: "16px",
                          color: "#364155",
                          display: "flex",
                          alignItems: "center"
                        }}
                      >
                        <Icon.PlusCircle size={14} className="me-2" style={{ color: "#556ee6" }} />
                        Create new test
                      </h6>
                      <Row>
                        <Col size={{xl: 12}} sx={{width: "100%"}} ref={dropdonwContainerRef}>
                          <Dropdown>
                            <Dropdown.Button
                              sx={{
                                whiteSpace: "normal", 
                                fontSize: "11px",
                                borderRadius: "8px",
                                padding: "10px 14px",
                                background: "#f7f9fc",
                                boxShadow: "0 1px 3px rgba(0, 0, 0, 0.04)",
                                border: "1px solid #e6ebf5",
                                color: "#495057",
                                width: "100%",
                                justifyContent: "flex-start",
                                height: "max-content",
                                "&:hover": {
                                  background: "#f7f9fc",
                                },
                                "&:disabled": {
                                  color: "#495057",
                                  background: "#f7f9fc",
                                }
                              }}
                              onClick={() => setDropdownWidth(dropdonwContainerRef.current?.clientWidth - 10 || 300)}
                              disabled={loadingCols || columns.length === 0}
                            >
                              {loadingCols ? 'Loading columns...' : 
                                (columns.length === 0 ? 'Unable to identify columns' : 
                                (selectedColumn || 'Select Column'))}
                            </Dropdown.Button>
                            <Dropdown.Menu
                              anchorOrigin={{
                                vertical: "top"
                              }}
                              anchorPosition={{
                                vertical: "top"
                              }}
                              transformOrigin={{
                                vertical: 'bottom',
                                horizontal: 'left',
                              }}
                              sx={{
                                padding: "8px 0",
                                [`& .${menuClasses.paper}`]: {
                                  width: `${dropdownWidth}px`,
                                  borderRadius: "0.2rem",
                                  border: "1px solid rgba(0, 0, 0, 0.15)",
                                },
                                [`& .${menuClasses.list}`]: {
                                  maxHeight: "300px"
                                },
                              }}
                            >
                              {columns.filter(column => column.trim() !== '').map((column, index) => (
                                <Dropdown.MenuItem 
                                  key={index} 
                                  onClick={() => setSelectedColumn(column)}
                                  sx={{
                                    padding: "0.25rem 1rem"
                                  }}
                                >
                                  {column}
                                </Dropdown.MenuItem>
                              ))}
                            </Dropdown.Menu>
                          </Dropdown>
                        </Col>
                        <Col xs={12} size={{xl: 12}} sx={{width: "100%"}}>
                          <Dropdown>
                            <Dropdown.Button
                              sx={{
                                whiteSpace: "normal", 
                                fontSize: "11px",
                                borderRadius: "8px",
                                padding: "10px 14px",
                                background: "#f7f9fc",
                                boxShadow: "0 1px 3px rgba(0, 0, 0, 0.04)",
                                border: "1px solid #e6ebf5",
                                color: "#495057",
                                width: "100%",
                                justifyContent: "flex-start",
                                height: "max-content",
                                "&:hover": {
                                  background: "#f7f9fc",
                                },
                                "&:disabled": {
                                  color: "#495057",
                                  background: "#f7f9fc",
                                }
                              }}
                              onClick={() => setDropdownWidth(dropdonwContainerRef.current?.clientWidth - 10 || 300)}
                            >
                              {selectedColumnTest || 'Select Test'}
                            </Dropdown.Button>
                            <Dropdown.Menu
                              anchorOrigin={{
                                vertical: "top"
                              }}
                              anchorPosition={{
                                vertical: "top"
                              }}
                              transformOrigin={{
                                vertical: 'bottom',
                                horizontal: 'left',
                              }}
                              sx={{
                                padding: "8px 0",
                                [`& .${menuClasses.paper}`]: {
                                  width: `${dropdownWidth}px`,
                                  borderRadius: "0.2rem",
                                  border: "1px solid rgba(0, 0, 0, 0.15)",
                                },
                                [`& .${menuClasses.list}`]: {
                                  maxHeight: "200px"
                                },
                              }}
                            >
                              {availableTests.column.map((test, index) => (
                                <Dropdown.MenuItem 
                                  key={index} 
                                  onClick={() => handleSelectColumnTest(test)}
                                  sx={{
                                    whiteSpace: "normal",
                                    padding: "0.25rem 1rem"
                                  }}
                                >
                                  {renderTestWithBadge(test.name)}
                                </Dropdown.MenuItem>
                              ))}
                            </Dropdown.Menu>
                          </Dropdown>
                        </Col>
                      </Row>
                      {Object.keys(selectedColumnTestConfig).length > 0 && (
                        <div 
                          className="mt-3"
                          style={{
                            background: "#f8f9fa",
                            borderRadius: "8px",
                            padding: "12px",
                            border: "1px solid #e9ecef"
                          }}
                        >
                          {renderInputFields(selectedColumnTestConfig)}
                        </div>
                      )}
                      <Button
                        variant="contained"
                        onClick={handleSaveNewTest}
                        disabled={!selectedColumn || !selectedColumnTest || !Object.entries(selectedColumnTestConfig).every(([key, value]) => 
                          key === 'config.error_if' || key === 'config.warn_if' || key === 'config.severity' || key === 'config.severity' ||
                          columnTestInputValues[key] !== undefined && columnTestInputValues[key] !== '' || 
                          (typeof value === 'string' && value.toLowerCase().includes('optional'))
                        )}
                        sx={{
                          width: "100%",
                          bgcolor: "#4BBF73",
                          color: "#fff",
                          marginTop: "1rem",
                          padding: "5px 16px",
                          borderRadius: "8px",
                          fontWeight: "500",
                          boxShadow: "rgba(0, 0, 0, 0.1) 0px 2px 4px",                          
                          "&:disabled": {
                            bgcolor: "#4BBF73",
                            color: "#fff",
                          }
                        }}
                      >
                        <Icon.Plus size={14} className="me-2" /> Add test
                      </Button>
                    </div>
                  )}
                  
                  <div className="d-flex justify-content-center mt-3">
                    <Button
                      variant={"contained"}
                      onClick={handleAddColumnTest}
                      sx={{
                        minWidth: '40px',
                        height: '40px',
                        padding: 0,
                        borderRadius: "50%",
                        bgcolor: showColumnDropdowns ? "#495057" : "#3F80EA",
                        "&:hover": {
                          bgcolor: showColumnDropdowns ? "#3e444a" : "#366dc7"
                        }
                      }}
                    >
                      {showColumnDropdowns ? <Icon.X size={20} /> : <Icon.Plus size={20} />}
                    </Button>
                  </div>
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>

            <Accordion defaultActiveKey="1" className="pl-0 mb-3">
              <Accordion.Item
                eventKey="1"
                style={{
                  borderRadius: '18px',
                  background: 'linear-gradient(to bottom, #fff, #f9fbfe)',
                  boxShadow: '0 8px 20px rgba(85, 110, 230, 0.1), 0 2px 8px rgba(0, 0, 0, 0.05)',
                  overflow: 'hidden',
                  border: 'none',
                  transition: 'all 0.05s ease-in-out'
                }}
              >
                <Accordion.Header
                  style={{
                    background: 'transparent',
                    border: 'none',
                    width: '100%',
                    borderRadius: '18px 18px 0 0',
                    transition: 'all 0.3s ease'
                  }}
                >
                  <div
                    className="d-flex align-items-center w-100" 
                    style={{ 
                      fontWeight: '600', 
                      fontSize: '12px', 
                      color: '#556ee6',
                      letterSpacing: '0.2px'
                    }}
                  >
                    <div
                      style={{
                        backgroundColor: 'rgba(85, 110, 230, 0.1)',
                        borderRadius: '50%',
                        width: '32px',
                        height: '32px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        marginRight: '12px',
                        transition: 'all 0.2s ease',
                        boxShadow: '0 2px 5px rgba(46, 202, 106, 0.2)'
                      }}
                    >
                      <Icon.Table size={16} />
                    </div>
                    Table Tests ({tableTestCount})
                  </div>
                </Accordion.Header>
                <Accordion.Body
                  style={{ 
                    padding: '18px 25px 22px',
                    backgroundColor: 'rgba(85, 110, 230, 0.03)',
                    borderTop: '1px solid rgba(85, 110, 230, 0.05)',
                    borderRadius: '0 0 18px 18px',
                    transition: 'all 0.3s ease-in-out'
                  }}
                >
                  {renderTableTests()}
                  
                  {showTableDropdowns && (
                    <div 
                      className="mt-4 mb-3"
                      style={{
                        background: "white",
                        borderRadius: "12px",
                        padding: "20px",
                        boxShadow: "0 4px 20px rgba(0, 0, 0, 0.05)",
                        border: "1px solid rgba(230, 235, 245, 0.8)"
                      }}
                    >
                      <h6 
                        style={{
                          fontSize: "12px",
                          fontWeight: "600",
                          marginBottom: "16px",
                          color: "#364155",
                          display: "flex",
                          alignItems: "center"
                        }}
                      >
                        <Icon.PlusCircle size={14} className="me-2" style={{ color: "#556ee6" }} />
                        Create new test
                      </h6>
                      <Row>
                        <Col size={{xl: 12}} sx={{width: "100%"}} ref={dropdonwContainerRef}>
                          <Dropdown>
                            <Dropdown.Button
                              sx={{
                                whiteSpace: "normal", 
                                fontSize: "11px",
                                borderRadius: "8px",
                                padding: "10px 14px",
                                background: "#f7f9fc",
                                boxShadow: "0 1px 3px rgba(0, 0, 0, 0.04)",
                                border: "1px solid #e6ebf5",
                                color: "#495057",
                                width: "100%",
                                justifyContent: "flex-start",
                                height: "max-content",
                                "&:hover": {
                                  background: "#f7f9fc",
                                }
                              }}
                              onClick={() => setDropdownWidth(dropdonwContainerRef.current?.clientWidth - 10 || 300)}
                            >
                              {selectedTableTest || 'Select Test'}
                            </Dropdown.Button>
                            <Dropdown.Menu
                              anchorOrigin={{
                                vertical: "top"
                              }}
                              anchorPosition={{
                                vertical: "top"
                              }}
                              transformOrigin={{
                                vertical: 'bottom',
                                horizontal: 'left',
                              }}
                              sx={{
                                padding: "8px 0",
                                [`& .${menuClasses.paper}`]: {
                                  width: `${dropdownWidth}px`,
                                  borderRadius: "8px",
                                  boxShadow: "0 10px 30px rgba(0, 0, 0, 0.1)",
                                  border: "1px solid #e6ebf5",
                                },
                                [`& .${menuClasses.list}`]: {
                                  maxHeight: "200px"
                                },
                              }}
                            >
                              {availableTests.table.map((test, index) => (
                                <Dropdown.MenuItem 
                                  key={index} 
                                  onClick={() => handleSelectTableTest(test)}
                                  sx={{
                                    whiteSpace: "normal",
                                    padding: "8px 16px",
                                    fontSize: "11px"
                                  }}
                                >
                                  {renderTestWithBadge(test.name)}
                                </Dropdown.MenuItem>
                              ))}
                            </Dropdown.Menu>
                          </Dropdown>
                        </Col>
                      </Row>
                      {Object.keys(selectedTableTestConfig).length > 0 && (
                        <div 
                          className="mt-3 py-2"
                          style={{
                            background: "#f8f9fa",
                            borderRadius: "8px",
                            padding: "0 12px",
                            border: "1px solid #e9ecef"
                          }}
                        >
                          {renderInputFields(selectedTableTestConfig)}
                        </div>
                      )}
                      <Button
                        variant="contained"
                        onClick={handleSaveNewTest}
                        disabled={!selectedTableTest || !Object.entries(selectedTableTestConfig).every(([key, value]) => 
                          tableTestInputValues[key] !== undefined && tableTestInputValues[key] !== '' || 
                          (typeof value === 'string' && value.toLowerCase().includes('optional'))
                        )}
                        sx={{
                          width: "100%",
                          bgcolor: "#4BBF73",
                          color: "#fff",
                          marginTop: "1rem",
                          padding: "5px 16px",
                          borderRadius: "8px",
                          fontWeight: "500",
                          boxShadow: "rgba(0, 0, 0, 0.1) 0px 2px 4px",
                          
                          "&:disabled": {
                            bgcolor: "#4BBF73",
                            color: "#fff",
                          }
                        }}
                      >
                        <Icon.Plus size={14} className="me-2" /> Add test
                      </Button>
                    </div>
                  )}
                  
                  <div className="d-flex justify-content-center mt-3">
                    <Button
                      variant={"contained"}
                      onClick={handleAddTableTest}
                      sx={{
                        minWidth: '40px',
                        height: '40px',
                        padding: 0,
                        borderRadius: "50%",
                        bgcolor: showTableDropdowns ? "#495057" : "#3F80EA",
                        "&:hover": {
                          bgcolor: showTableDropdowns ? "#3e444a" : "#366dc7"
                        }
                      }}
                    >
                      {showTableDropdowns ? <Icon.X size={20} /> : <Icon.Plus size={20} />}
                    </Button>
                  </div>
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>
          </>
        )}
        
        <div className="mt-auto">
          <Button
            variant="contained" 
            onClick={handleSaveTests}
            disabled={isSaving}
            sx={{
              width: "100%",
              bgcolor: "#3F80EA",
              padding: "0.5rem 1rem",
              borderRadius: "8px",
              
              "&:hover": {
                bgcolor: "#366dc7",
              },

              "&:disabled": {
                bgcolor: "#3F80EA",
                color: "#fff"
              }
            }}
          >
            {isSaving ? (
              <CircularProgress size={20} thickness={4} style={{ color: 'white', marginRight: '8px' }} />
            ) : null}
            <div style={{ 
              display: "flex", 
              justifyContent: "center", 
              alignItems: "center", 
              width: "100%",
              position: "relative"
            }}>
              <span style={{ fontWeight: "600", letterSpacing: "0.3px", fontSize: "12px" }}>
                Save Tests
              </span>
              <div style={{ 
                display: "flex", 
                alignItems: "center", 
                justifyContent: "center",
                backgroundColor: "rgba(255, 255, 255, 0.2)",
                borderRadius: "50%",
                padding: "5px",
                height: "24px",
                width: "24px",
                position: "absolute",
                right: "0"
              }}>
                <Icon.Check size={14} />
              </div>
            </div>
          </Button>
        </div>

      </section>
    </ResizableBox>
  );
}
